// import React from "react";
import {Outlet} from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
// import ErrorBoundary from './components/Title';
// import Table from './components/Table';
// import Table_blogers from './components/Table_blogers';
// import Posts from './components/Posts';

const Layout = () => {
    return(
        <div>
            <Header />
            <main>
                <Outlet />
            </main>
            <Footer />
        </div>

    );
}

export {Layout}